import React from 'react';

const Payment = () => {
    return (
        <div>
            <h1 style={{
                color: "#0f0c2f",
                fontWeight: 700,
            }}>Payment Method coming soon. Stay tuned.</h1>
        </div>
    );
};

export default Payment;